"use strict";
window.theme = window.theme || {}
theme.ComponentsHeaderBubbleBasket = function() {
    function ComponentsHeaderBubbleBasket() {
        this.container = {
            bubblecount: document.querySelectorAll('.header-cart-item > a > span.Header__CartDot')
        };        
        this.load();             
    }
    ComponentsHeaderBubbleBasket.prototype.load = function() {
        var _ = this;
        document.addEventListener('DOMContentLoaded', () => {
            _.cartcount();
        })            
    }
    ComponentsHeaderBubbleBasket.prototype.cartcount = function() {
        var _ = this;     
        if(_.container.bubblecount.length > 0) {
            fetch(window.Shopify.routes.root+'cart.js')
            .then(response => response.json())
            .then(data => {
                if(_.container.bubblecount.length > 0) {
                    _.container.bubblecount.forEach(bubble => {
                        bubble.textContent = '('+data.item_count+')';
                        bubble.classList.add('is-visible');
                    })
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });
        }
    }

    theme.ComponentsHeaderBubbleBasket = new ComponentsHeaderBubbleBasket;
}

theme.ComponentsHeaderBubbleBasket();
